import React, { useEffect, useState } from "react"
import Pricing from "./getPricing"

// if <main> has the attribute product_code we are on a Loc Act Page 
// pageProductCode is set to this value and used if a pricing item should have a book button but travelizeProductCode is not set
const findProductCodeOnPage = () => {
  
  // grab the product code from <main> if it is set
  let mainEl = document.querySelector( 'main[product_code]' )
  if( !mainEl ) {
    return false
  }

  return mainEl.getAttribute( 'product_code' )

}

export default ({ pricingItems }) => {

  // if any of the pricingItems have a link we should show all cards expanded
  const [expanded, setExpanded] = useState( false )
  const [pageProductCode, setPageProductCode] = useState( false )
  
  useEffect(() => {

    setPageProductCode( findProductCodeOnPage )

    pricingItems.forEach( (item) => {
      if( item.link ) {
        setExpanded( true )
      }
    })

  },[ pricingItems ])

  const Items = pricingItems.map((item, index) => {
    return  <Pricing key={ index }
               label={ item.label }
               title={ item.title }
               price={ item.price }
               listTitle={ item.listTitle }
               list={ item.list }
               isFeatured={ item.isFeatured }
               link={ item.link }
               seeAllText={ item.buttonText }
               expanded={ expanded }
               disableBookButton={ item.disableBookButton }
               travelizeProductCode={ item.travelizeProductCode ? item.travelizeProductCode : pageProductCode }
      />
    }
  );

  return (
    <section className="u-grid u-container u-section-spacing">
      { Items }
    </section>
  )
}
